import { useState, useEffect } from 'react';
import './UpdateBanner.css';

export function UpdateBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handler = () => setShow(true);
    window.addEventListener('sw-update-available', handler);
    return () => window.removeEventListener('sw-update-available', handler);
  }, []);

  if (!show) return null;

  return (
    <div className="update-banner" role="status">
      <span>A new version is available!</span>
      <button className="update-banner-btn" onClick={() => window.location.reload()}>
        Refresh
      </button>
    </div>
  );
}
